import React from "react";
import { useTranslation } from "react-i18next";
import reportsIcon from "../../assets/images/reports-black-icon.png";
import UserMasConfirm from "../../entities/UserMasConfirm";
import { getFundLabel } from "../../utils/helpers/getFundLabel";
import WhitePdfButton from "../WhitePdfButton/WhitePdfButton";
import { useSelector } from "react-redux";


import "./MasConfirms.scss";

const MasConfirms = (props: { masConfirm: UserMasConfirm , FundLabels:any }) => {
  const {userFunds } = useSelector(
      (state: any) => state.UserReducer
  );

  const { t } = useTranslation("common");

  return (
    
      <li className="mas-confirm-details">

        <div className="mas-confirm-text-container">
          <div className="d-flex align-items-center mas-confirm-text-wrapper">
            <img
              src={reportsIcon}
              className="mas-confirm-reports-icon"
              alt=""
            />
            {/* <span className="mas-confirm-approve-text">
              {`${t("general.masConfirm")}`}
            </span> */}
            <span className="mas-confirm-year-text">
              {`${t("general.masConfirm")}`} {props.masConfirm.dolreportyear}
            </span>
            {/* <span className="mas-confirm-separator">|</span> */}
          </div>
          <div className="mas-confirm-fund-label">
            {props?.FundLabels?.fundLabel}
          </div>
        </div>
        <WhitePdfButton masConfirmData={props.masConfirm} />
      </li>
    
  );
};

// getFundLabel(
//   parseInt(props.masConfirm.fundcode)

export default MasConfirms;
